import { render } from "./MachineComponent.vue?vue&type=template&id=87d19eee"
import script from "./MachineComponent.vue?vue&type=script&lang=js"
export * from "./MachineComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\96keh\\Desktop\\dev\\liof\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__